module.exports = __webpack_public_path__ + "img/map_1791552667418_65200.4739a909.jpg";